export const text = {
    'text/cache-manifest': {
        extensions: ['appcache', 'manifest'],
        source: 'iana',
    },
    'text/calendar': {
        extensions: ['ics', 'ifb'],
        source: 'iana',
    },
    'text/css': {
        charset: 'UTF-8',
        extensions: ['css'],
        source: 'iana',
    },
    'text/csv': {
        extensions: ['csv'],
        source: 'iana',
    },
    'text/html': {
        extensions: ['html', 'htm', 'shtml'],
        source: 'iana',
    },
    'text/markdown': {
        extensions: ['markdown', 'md'],
        source: 'iana',
    },
    'text/mathml': {
        extensions: ['mml'],
        source: 'nginx',
    },
    'text/n3': {
        charset: 'UTF-8',
        extensions: ['n3'],
        source: 'iana',
    },
    'text/plain': {
        extensions: ['txt', 'text', 'conf', 'def', 'list', 'log', 'in', 'ini'],
        source: 'iana',
    },
    'text/prs.lines.tag': {
        extensions: ['dsc'],
        source: 'iana',
    },
    'text/richtext': {
        extensions: ['rtx'],
        source: 'iana',
    },
    'text/rtf': {
        extensions: ['rtf'],
        source: 'iana',
    },
    'text/sgml': {
        extensions: ['sgml', 'sgm'],
        source: 'iana',
    },
    'text/shex': {
        extensions: ['shex'],
        source: 'iana',
    },
    'text/spdx': {
        extensions: ['spdx'],
        source: 'iana',
    },
    'text/tab-separated-values': {
        extensions: ['tsv'],
        source: 'iana',
    },
    'text/troff': {
        extensions: ['t', 'tr', 'roff', 'man', 'me', 'ms'],
        source: 'iana',
    },
    'text/turtle': {
        charset: 'UTF-8',
        extensions: ['ttl'],
        source: 'iana',
    },
    'text/uri-list': {
        extensions: ['uri', 'uris', 'urls'],
        source: 'iana',
    },
    'text/vcard': {
        extensions: ['vcard'],
        source: 'iana',
    },
    'text/vnd.curl': {
        extensions: ['curl'],
        source: 'iana',
    },
    'text/vnd.curl.dcurl': {
        extensions: ['dcurl'],
        source: 'apache',
    },
    'text/vnd.curl.mcurl': {
        extensions: ['mcurl'],
        source: 'apache',
    },
    'text/vnd.curl.scurl': {
        extensions: ['scurl'],
        source: 'apache',
    },
    'text/vnd.dvb.subtitle': {
        extensions: ['sub'],
        source: 'iana',
    },
    'text/vnd.familysearch.gedcom': {
        extensions: ['ged'],
        source: 'iana',
    },
    'text/vnd.fly': {
        extensions: ['fly'],
        source: 'iana',
    },
    'text/vnd.fmi.flexstor': {
        extensions: ['flx'],
        source: 'iana',
    },
    'text/vnd.graphviz': {
        extensions: ['gv'],
        source: 'iana',
    },
    'text/vnd.in3d.3dml': {
        extensions: ['3dml'],
        source: 'iana',
    },
    'text/vnd.in3d.spot': {
        extensions: ['spot'],
        source: 'iana',
    },
    'text/vnd.sun.j2me.app-descriptor': {
        charset: 'UTF-8',
        extensions: ['jad'],
        source: 'iana',
    },
    'text/vnd.wap.wml': {
        extensions: ['wml'],
        source: 'iana',
    },
    'text/vnd.wap.wmlscript': {
        extensions: ['wmls'],
        source: 'iana',
    },
    'text/vtt': {
        charset: 'UTF-8',
        extensions: ['vtt'],
        source: 'iana',
    },
    'text/x-asm': {
        extensions: ['s', 'asm'],
        source: 'apache',
    },
    'text/x-c': {
        extensions: ['c', 'cc', 'cxx', 'cpp', 'h', 'hh', 'dic'],
        source: 'apache',
    },
    'text/x-component': {
        extensions: ['htc'],
        source: 'nginx',
    },
    'text/x-fortran': {
        extensions: ['f', 'for', 'f77', 'f90'],
        source: 'apache',
    },
    'text/x-java-source': {
        extensions: ['java'],
        source: 'apache',
    },
    'text/x-nfo': {
        extensions: ['nfo'],
        source: 'apache',
    },
    'text/x-opml': {
        extensions: ['opml'],
        source: 'apache',
    },
    'text/x-pascal': {
        extensions: ['p', 'pas'],
        source: 'apache',
    },
    'text/x-setext': {
        extensions: ['etx'],
        source: 'apache',
    },
    'text/x-sfv': {
        extensions: ['sfv'],
        source: 'apache',
    },
    'text/x-uuencode': {
        extensions: ['uu'],
        source: 'apache',
    },
    'text/x-vcalendar': {
        extensions: ['vcs'],
        source: 'apache',
    },
    'text/x-vcard': {
        extensions: ['vcf'],
        source: 'apache',
    },
    'text/xml': {
        extensions: ['xml'],
        source: 'iana',
    },
} as const;
